import GetSupportPanel from ".";

export default function GetSupportPanelExamples() {
  return <GetSupportPanel />;
}
